const blue = {
  light: '#A6DFFF',
  main: '#4384F5',
  dark: '#507BE9'
};
export default blue;